import { Fade } from "@mui/material";
import cn from "classnames";
import useTranslate from "../../hooks/useTranslate";
import { IBlockWithErrorProps } from "./BlockWithError.props";
import styles from "./BlockWithError.module.scss";

const BlockWithError = ({ message, updateHandler, withBackground = false, ...props }: IBlockWithErrorProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Fade in={true} timeout={500}>
			<div className={styles.error} {...props}>
				<div className={cn(styles.errorInner, { [styles.errorWithBackground]: withBackground })}>
					<span className={styles.message}>
						{/* с разделителем ":" переводим только первую часть */}
						{message?.includes(":") ? (
							<>
								{translate(message.replace(/:.*$/gm, ""))}
								{message.replace(/^.*:/gm, ":")}
							</>
						) : (
							translate(message || "title_loadFailed")
						)}
					</span>
					<span className={styles.update} onClick={updateHandler}>
						{translate("button_update")}
					</span>
				</div>
			</div>
		</Fade>
	);
};

export default BlockWithError;
